import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
    selector: 'app-menu-notification',
    templateUrl: './menu-notification.component.html',
    styleUrls: ['./menu-notification.component.css'],
    animations: [
        trigger('slideInOut', [
            state('void', style({
                top: '-100px',
                opacity: 0
            })),
            state('visible', style({
                top: '10vh',
                opacity: 1
            })),
            transition('void => visible', [
                animate('300ms ease-in')
            ]),
            transition('visible => void', [
                animate('300ms ease-out')
            ])
        ])
    ],
    standalone: false
})
export class MenuNotificationComponent implements OnInit, OnDestroy {
  constructor(
    private notificationService: NotificationService,
  ) {}

  private destroy$ = new Subject<void>();
  private timeoutId: any = null;
  notification: { message: string; duration: number } | null = null;

  ngOnInit(): void {
    this.notificationService.notifications$
      .pipe(takeUntil(this.destroy$))
      .subscribe(notification => {
        // Закрываем предыдущее уведомление, если оно активно
        this.closeNotification();
        // Показываем новое уведомление
        this.notification = notification;
        // Устанавливаем таймер для автоматического закрытия
        this.timeoutId = setTimeout(() => {
          this.closeNotification();
        }, notification.duration);
        console.log('NotificationComponent | ngOnInit() | Showing notification:', notification.message);
      });
  }

  closeNotification(): void {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
    this.notification = null;
    console.log('NotificationComponent | closeNotification() | Notification closed');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
